import { CircularProgress } from '@mui/material';
import type React from 'react';

const LoadingComponent: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress color="secondary" />
    </div>
  );
};

export default LoadingComponent;
